import React from 'react'
import './ViewAcceptRejStyle.css'
import '../ViewCallDetails/ViewCallDetailsStyle.css'
import Button from '../../Button/Button';
import { Link } from 'react-router-dom';
import moment from 'moment';

const ViewAcceptRej = ({ isActive, setIsActive, mentor, handleAcceptRequest, handleRejectRequest }) => {

    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>

            <div className={`popupContainer poupCDcontainer`}>
                <div className="popupBody AdAcceptRejwarp">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={() => setIsActive(false)} />
                    </span>
                    <div className="flex-center headingaccpt">
                        <h3 className='heading-2'>Mentor Details</h3>
                    </div>

                    <div className='AgendapopupCallhistory dscallreqwrap'>
                        <div className='AnswerFaq  AnsForNewFaqUsers'>
                            <div className="answerFaqnew calldsrequst">
                                <div className="profileHistoryDeatils f-items-center">
                                    <div className='userpopupimg'>
                                        <img src={mentor?.profileImg ? mentor?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                    </div>
                                    <div className="CallDetailsNameData flex">
                                        <div className="NameDetails">
                                            <h3 className='namelink pointer'>{mentor?.firstName ? `${mentor?.firstName} ${mentor?.lastName}` : "---"}</h3>
                                            <p className="text2 capitilize">{mentor?.profession?.designation ? mentor?.profession?.designation: "---"}</p>
                                        </div>
                                        <span className='Mentorspan Designspan'>Mentor</span>
                                    </div>
                                </div>
                                <div className=''>
                                    <div className='callrequestdslist'>
                                        <ul>
                                            <li> <span>Email: </span>{mentor?.email ? mentor?.email : "---"}</li>
                                            <li> <span>Current Company: </span>{mentor?.profession?.company ? mentor?.profession?.company : "---"}</li>
                                
                                        </ul>
                                        <ul>
                                            <li> <span>Phone Number: </span>{mentor?.mobileNumber ? mentor?.mobileNumber : "---"}</li>
                                            <li> <span>Total Years of Experience: </span>{mentor?.profession?.yrsOfExp ? mentor?.profession?.yrsOfExp : "---"}</li>
                                        </ul>
                                    </div>
                                    <ul className='mt-20'>
                                    <li> <span>Functional focus area: </span>{mentor?.interests?.length > 0 ? mentor?.interests?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {index ? "," : " "}
                                            {item?.interest ? item?.interest: "---"}
                                        </React.Fragment>
                                        )) : "---"}</li>
                                    <li> <span>Mentoring On:</span>{mentor?.topics?.length > 0 ? mentor?.topics?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {index ? "," : " "}
                                            {item?.Topic ? item?.Topic: "---"}  
                                        </React.Fragment>
                                        )) : "---"}
                                    </li>

                                    </ul>
                                    <ul className='mt-20'>
                                        <li> <span>Linkedin Profile: </span>{mentor?.linkedin ? <a className='textBlue' target='_blank' href={mentor?.linkedin?.slice(0,4) === "http" ? mentor?.linkedin : "https://" + mentor?.linkedin} rel='noreferrer' >{mentor?.linkedin}</a> : "---"}</li>
                                        <li> <span>Date: </span>{mentor?.createdAt ? moment(mentor?.createdAt).format("DD MMMM, YYYY") : "---"}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='flex-center gap-20 mt-20'>
                        <Button name={'Accept'} className={'Acceptbtn'} onClick={handleAcceptRequest} />
                        <Button name={'Reject'} className={'Rejectbtn'} onClick={handleRejectRequest} />
                    </div>


                </div>
            </div>
        </div>
    )
}

export default ViewAcceptRej